import React, { useEffect, useState } from 'react';
import { LightHeader } from '../HeaderAndNavigationBar';
import { IonApp, IonButton, IonCard, IonCardContent, IonCardHeader, IonContent, IonNote, IonPage, IonTextarea } from '@ionic/react';
import { Image } from '../volunteers/Image';
import { EditableImage } from '../volunteers/EditableImage';

export const EditRafflePage: React.FC = () => {


    const [, setCount] = useState(1);

    const params = new URLSearchParams(window.location.hash.split('?')[1]);

    const imagePath = params.get('image') || undefined;

    const program = params.get('program') || 'Spartan Robotics';

    const from = params.get('from') || program;

    const p1 = params.get('p1') || 'I am doing Robotics again and we already competed in our first tournament of the year! 5 more to go and our next one is Nov 23rd!';
    const p2 = params.get('p2') || 'We started our raffle to help fund the rest of our season, we have about $925 to go. I hope you can help out and I hope you win!';
    useEffect(() => {
        const onHashChange = () => {
            setCount(count => count + 1);
        }
        window.addEventListener('hashchange', onHashChange);

        return () => {
            window.removeEventListener('hashchange', onHashChange);
        }
    })

    const url = `/#/raffle?${params.toString()}`;
    // const url = `https://www.blackhillsrobotics.org/#/raffle?${params.toString()}`;

    return (
        <IonApp>
            <IonPage>
                <LightHeader title="Raffle Link Builder" />
                <IonContent>
                    <div style={{ margin: 20 }}>
                        <IonNote >

                            Here you can customize your own link to send to family.

                            <ol>
                                <li>Click the image to upload your own </li>
                                <li>Change the text in either or both paragaraphs</li>
                                <li>Change the from to your child or family</li>
                            </ol>

                            Then click the link at the bottom to get a custom link you can share with your friends and family.
                        </IonNote>
                    </div>

                    <IonCard>
                        <IonCardHeader>
                            {/* TODO: flash of wrong image */}
                            <EditableImage
                                src={imagePath}
                                onChange={x => {
                                    params.set('image', x);
                                    // I need a hash aware version !?
                                    const parts = window.location.hash.split('?');
                                    window.location.hash = `${parts[0]}?${params.toString()}`;
                                }}
                                onIsUploading={() => {

                                }}
                            />
                        </IonCardHeader>
                        <IonCardContent>
                            <p>
                                Dear Friends and Family,
                                <br />
                                <IonTextarea value={p1} autoGrow onIonChange={e => {
                                    params.set('p1', e.detail.value || '');
                                    const parts = window.location.hash.split('?');
                                    window.location.hash = `${parts[0]}?${params.toString()}`;

                                }} />
                                {/* make editable */}
                                <br/>
                                {/* make editable */}
                                <IonTextarea value={p2} autoGrow onIonChange={e => {
                                    params.set('p2', e.detail.value || '');
                                    const parts = window.location.hash.split('?');
                                    window.location.hash = `${parts[0]}?${params.toString()}`;
                                }} />
                                <br/>
                                Thanks!
                                <br />
                                <br />
                                <IonTextarea value={from} autoGrow onIonChange={e => {
                                    params.set('from', e.detail.value || '');
                                    const parts = window.location.hash.split('?');
                                    window.location.hash = `${parts[0]}?${params.toString()}`;
                                }}  />
                            </p>
                            <IonButton href="https://givebutter.com/XF5OnG" disabled>Support our Raffle</IonButton>
                            <p>
                                PS - make sure you choose <strong>{program}</strong> when purchasing your ticket so our club gets credit.
                            </p>
                            {/* will eventually be making a shortened url */}
                            <a href={url} target='_blank' rel="noreferrer">Test your Link</a>
                        </IonCardContent>
                    </IonCard>
                </IonContent>
            </IonPage>
        </IonApp>
    )
}


export const RafflePage: React.FC = () => {
    console.log('in here');
    const params = new URLSearchParams(window.location.hash.split('?')[1]);

    const imagePath = params.get('image') || undefined;

    const program = params.get('program') || 'Spartan Robotics';

    const from = params.get('from') || program;

    const title = params.get('title') || `${program} Raffle`;

    const p1 = params.get('p1') || 'I am participating in Robotics again and we are already competed in our first tournament of the year!';
    const p2 = params.get('p2') || 'We have started our raffle to help fund the rest of our season, we have about $925 to go. I hope you can help out and I hope you win!';

    return (
        <IonApp>
            <IonPage>
                <LightHeader title={title} />
                <IonContent>
                    <IonCard>
                        <IonCardHeader>
                            <Image src={imagePath} />
                        </IonCardHeader>
                        <IonCardContent>
                            <p>
                                Dear Friends and Family,
                                <br />
                                <br />
                                {p1}
                                <br/>
                                <br/>
                                {p2}
                                <br/>
                                <br/>
                                Thanks!
                                <br />
                                <br />
                                {from}
                            </p>
                            <IonButton href="https://givebutter.com/XF5OnG">Support our Raffle</IonButton>
                            <p>
                                PS - Please choose <strong>{program}</strong> when purchasing your ticket so our club gets credit.
                            </p>
                        </IonCardContent>
                    </IonCard>
                </IonContent>
            </IonPage>
        </IonApp>
    )
}
